import * as actions from './slice'

export const getSkillBite = {
  eventName: 'skillBiteGet',
  onSuccess: {
    action: actions.setSkillBite,
    redux: true
  }
}

export const trackStartSession = {
  eventName: 'skillBiteTrackStartSession'
}

export const trackFinishSession = {
  eventName: 'skillBiteTrackFinishSession'
}

export const getSkillBiteSession = ({ onSuccess }) => {
  return {
    eventName: 'skillBiteGetSession',
    onSuccess: [
      {
        action: actions.setSession,
        redux: true
      },
      onSuccess
    ]
  }
}

export const saveQuizAnswer = {
  eventName: 'skillBiteSaveQuizAnswer'
}

export const getPage = ({ onSuccess }) => {
  return {
    eventName: 'skillBiteGetPage',
    onSuccess: [
      {
        action: actions.setCurrentPageWithBlocks,
        redux: true
      },
      onSuccess
    ]
  }
}
